///<reference path="../api.d.ts" />

module agencyRegistration.service {
    
    export class CreateService {
        // Dependencies
        $http: ng.IHttpService
        $q: ng.IQService
        api: API.Client.DefaultApi;
        banksService: banks.BanksService;
        branchesService: branches.BranchesService;
        addressService: address.AddressService;
        $commonData: any;
        
        branchesConst : Array<API.Client.Branch> = [
            {cvcBranchCode : 600,name:'CAMPINAS - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 900,name:'SAO PAULO - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 901,name:'ATENDIMENTO AGENCIAS RS'},
            {cvcBranchCode : 1291,name:'BH - AT AGENCIAS'},
            {cvcBranchCode : 1400,name:'ABC - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 1401,name:'ATENDIMENTO AGÊNCIAS ESTRANGEIRAS'},
            {cvcBranchCode : 170,name:'CURITIBA - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 1801,name:'PARA E MARANHAO_ATENDIMENTO AGENCIA'}, 
            {cvcBranchCode : 2002,name:'BRASILIA - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 2100,name:'INTERIOR DO PARANÁ - AT AGÊNCIAS'},
            {cvcBranchCode : 2200,name:'UBERLANDIA - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 2300,name:'RECIFE - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 2400,name:'NATAL - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 2500,name:'FORTALEZA - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 2600,name:'CAMPO GRANDE - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 2700,name:'CUIABA - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 2901,name:'AT_AGÊNCIAS  PARÁ'},
            {cvcBranchCode : 3600,name:'VITORIA - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 3900,name:'MANAUS - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 3980,name:'BOA VISTA - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 4500,name:'PORTO VELHO - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 4700,name:'BAURU - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 4810,name:'JUNDIAI - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 5010,name:'LOJA PALMAS - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 6900,name:'MACAPA - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 7000,name:'TERESINA - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 7280,name:'BRAGANCA PAULISTA - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 7400,name:'RIO BRANCO - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 7910,name:'POÇOS DE CALDAS - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 8200,name:'ARACAJU - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 8300,name:'JOAO PESSOA - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 8570,name:'SSA SALVADOR ATENDIMENTO AGENCIAS'},
            {cvcBranchCode : 8600,name:'LOJA MACEIO - AT AGÊNCIAS '},
            {cvcBranchCode : 8700,name:'SAO JOSE DO RIO PRETO - AT AGÊNCIAS'},
            {cvcBranchCode : 8900,name:'GOIÂNIA - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 9000,name:'FLORIANÓPOLIS - AT AGÊNCIAS'},
            {cvcBranchCode : 9400,name:'SANTOS - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 9500,name:'SAO JOSE CAMPOS - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 9601,name:'GUARULHOS - LOJA / AT AGÊNCIAS'},
            {cvcBranchCode : 9701,name:'RIBEIRÃO PRETO - ATEND. AGÊNCIA'},
            {cvcBranchCode : 9751,name:'FRANCA - ATENDIMENTO AGÊNCIAS'},
            {cvcBranchCode : 9810,name:'HIPER WALMART OSASCO - LOJA/AT AGÊNCIAS'},
            {cvcBranchCode : 9991,name:'RIO DE JANEIRO / JUIZ DE FORA ATENDIMENTO AGÊNCIAS'}
       ];
        
        // Properties
        fieldOptions: any = {};

        /*@ngInject*/
        constructor(
            $http: ng.IHttpService, 
            $q: ng.IQService, 
            banksService: banks.BanksService,
            branchesService: branches.BranchesService,
            addressService: address.AddressService,
            $commonDataService
        ) {
            this.$http = $http;
            this.$q = $q;
            this.api = new API.Client.DefaultApi(this.$http);
            this.banksService = banksService;
            this.$commonData = $commonDataService;
            this.branchesService = branchesService;
            this.addressService = addressService;
        };
        
        createAgency(request:API.Client.AgencyModel): ng.IPromise<string> {
            //SetUserData
            request.user = "WEBTUR"; request.userIp = "1.1.1.1";
            //SetUserData
            return this.api.agenciesPost(request).then(response => {
                return response.data;
            });
        };
        
        getFields(): ng.IPromise<any> {
            let defer = this.$q.defer(), allPromises = [];
            
            // States
            this.fieldOptions.states = this.$commonData.states;
            
            // Get Branches
            this.fieldOptions.branches = this.branchesConst;
            
            // Get Banks
            allPromises.push(this.banksService.getBanks().then(banks => {
                this.fieldOptions.banks = banks;
            }));
            
            // Get Cities
            allPromises.push(this.addressService.getCity("BR", "SP").then(cities => {
                this.fieldOptions.cities = cities;
            }));
            
            // Resolve all promises
            this.$q.all(allPromises).finally(() => {
               defer.resolve(this.fieldOptions); 
            });
            
            return defer.promise;
        };
    }
}
angular.module('agencyRegistrationApp').service('createService', agencyRegistration.service.CreateService);